import { TableCell as MuiTableCell, TableCellProps } from '@mui/material';
import clsx from 'clsx';
import { ArrowUpIcon } from '../icons';
import styles from './style.module.css';

interface Props extends TableCellProps {
  selected: boolean;
  order: 'asc' | 'desc';
}

const TableCellHeader = ({ children, selected, order, ...props }: Props) => {
  return (
    <MuiTableCell
      className={styles.tableHeader}
      data-active={selected}
      {...props}
      sx={{ fontWeight: 'inherit' }}
    >
      {children}
      {selected && (
        <ArrowUpIcon
          className={clsx(styles.sortIcon, order === 'desc' && styles.rotate)}
        />
      )}
    </MuiTableCell>
  );
};

export default TableCellHeader;
